import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import {
  ApiService,
  StreetSubjectProfileResponse,
} from '../../../shared/services/api.service';

interface StreetSubjectDialogData {
  subjectId: string;
  fallbackName: string | null;
}

@Component({
  selector: 'app-street-subject-profile-dialog',
  templateUrl: './street-subject-profile-dialog.component.html',
  styleUrls: ['./street-subject-profile-dialog.component.css'],
})
export class StreetSubjectProfileDialogComponent implements OnInit {
  isLoading = true;
  response: StreetSubjectProfileResponse | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: StreetSubjectDialogData,
    private apiService: ApiService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      this.response = await firstValueFrom(
        this.apiService.getStreetSubjectProfile(this.data.subjectId)
      );
    } finally {
      this.isLoading = false;
    }
  }

  getFullName(): string {
    const p = this.response?.profile;
    const first = (p?.firstName || '').trim();
    const surname = (p?.surname || '').trim();
    const full = [first, surname].filter(Boolean).join(' ').trim();
    return full || this.data.fallbackName || 'N/A';
  }

  getPhoneRows(): Array<{ number: string; lastUpdatedDate: string | null }> {
    return (this.response?.profile?.topTelephoneNumbers || [])
      .filter((phone) => (phone.number || '').trim().length > 0)
      .map((phone) => ({
        number: (phone.number || '').trim(),
        lastUpdatedDate: (phone.lastUpdatedDate || '').trim() || null,
      }));
  }
}
